import { global } from "./global";
import { chip } from "./components/chip";
import { button } from "./components/button";
import { breadcrumb } from "./components/breadcrumb";
import { select } from "./components/select";
import { inputnumber } from "./components/inputnumber";
import { inputtext } from "./components/inputtext";
import { datatable } from "./components/datatable";
import { paginator } from "./components/paginator";
import { autocomplete } from "./components/autocomplete";
import { menu } from "./components/menu";
import { message } from "./components/message";
import { dialog } from "./components/dialog";
import { panelmenu } from "./components/panelmenu";
import { progressbar } from "./components/progressbar";
import { confirmdialog } from "./components/confirmdialogue";
import { checkbox } from "./components/checkbox";
import { toast } from "./components/toast";
import { tabs } from "./components/tabs";
import { tablist } from "./components/tablist";
import { tabpanels } from "./components/tabpanels";
import { tabpanel } from "./components/tabpanel";
import { tab } from "./components/tab";
import { textarea } from "./components/textarea";
import { stepper } from "./components/stepper";
import { steplist } from "./components/steplist";
import { steppanels } from "./components/steppanels";
import { step } from "./components/step";
import { steppanel } from "./components/steppanel";
import { slider } from "./components/slider";
import { progressspinner } from "./components/progressspinner";
import { radiobutton } from "./components/radiobutton";
import { togglebutton } from "./components/togglebutton";
import { selectbutton } from "./components/selectbutton";
import { accordion } from "./components/accordion";
import { accordionpanel } from "./components/accordionpanel";
import { accordionheader } from "./components/accordionheader";
import { accordioncontent } from "./components/accordioncontent";
import { datepicker } from "./components/datepicker";
import { inputgroup } from "./components/inputgroup";
import { inputgroupaddon } from "./components/inputgroupaddon";
import { multiselect } from "./components/multiselect";
import { toggleswitch } from "./components/toggleswitch";
import { popover } from "./components/popover";

import { tooltip } from "./directives/tooltip";
import { type PrimeVuePTOptions } from "primevue/config";
import PVTooltip from "primevue/tooltip";

export const defaultTheme: PrimeVuePTOptions = {
  global,

  // Download component presets here: https://tailwind.primevue.org/builder/
  chip,
  button,
  breadcrumb,
  select,
  inputnumber,
  inputtext,
  datatable,
  paginator,
  autocomplete,
  menu,
  message,
  dialog,
  panelmenu,
  progressbar,
  confirmdialog,
  checkbox,
  toast,
  tabs,
  tablist,
  tabpanels,
  tabpanel,
  tab,
  textarea,
  stepper,
  steplist,
  steppanels,
  step,
  steppanel,
  slider,
  progressspinner,
  radiobutton,
  togglebutton,
  selectbutton,
  accordion,
  accordionpanel,
  accordionheader,
  accordioncontent,
  datepicker,
  inputgroup,
  inputgroupaddon,
  multiselect,
  toggleswitch,
  popover,
  directives: {
    tooltip
  }
};

export const primevueDirectives = [
  { directive: PVTooltip, name: "pv-tooltip" }
];

export { taiPreset } from "./preset";
